import React, { useContext } from 'react'
import { PureSelect, Tooltip, TooltipTrigger } from 'chemistry'
import { TranslateContext } from 'client/common/translator'
import classNames from 'classnames'
import { useDispatch, useSelector } from 'react-redux'
import { useActionProps } from 'client/fragments/listerFragment/hooks/useActionProps'
import { onSortByChange } from 'client/fragments/listerFragment/store/actions/pageActions'

const Sorting = ({ id, disabled, isFilterPanel, className }) => {
  const t = useContext(TranslateContext)
  const handlerCommonProps = useActionProps()
  const dispatch = useDispatch()
  const onSortChange = onSortByChange({ ...handlerCommonProps, dispatch })
  const sort = useSelector(it => it.data.sort)

  const options = sort?.map(({ id, name, selected }) => ({
    value: id,
    label: name,
    id,
    selected,
    title: name
  }))

  return (
    <div
      className={classNames('mxd-sorting', 'flex', className, {
        'items-center': !isFilterPanel,
        'justify-end': !isFilterPanel,
        'gap-1': !isFilterPanel,
        'flex-column': isFilterPanel
      })}
      data-react-type='Sorting'
    >
      <label
        htmlFor={id}
        style={{ whiteSpace: 'nowrap' }}
        className={classNames({
          bold: isFilterPanel,
          'pb-0-75': isFilterPanel
        })}
      >
        {`${t('lister.sorting.label')}${':'}`}
        <Tooltip
          fontSize='14px'
          color='ui-02-darkest'
          m='12px 0 0 6px'
          content={t('lister.sortings.legal.description')}
          placement='bottom'
        >
          <TooltipTrigger ml='8px' display='inline-block' borderColor='ui-02-darkest' color='ui-02-darkest' />
        </Tooltip>
      </label>
      <PureSelect
        id={id}
        onChange={e => onSortChange(e.target.value)}
        width={isFilterPanel ? '100%' : '232px'}
        size='md'
        fontSize='sm'
        options={options}
        isDisabled={disabled}
        name='sortBy'
        title={t('lister.sorting.label')}
      />
    </div>
  )
}

export default Sorting
